module.exports = __webpack_public_path__ + "img/sdg_icon_13.1282c68b.png";